import React, { useState } from "react";
import HeadingText from "components/common/HeadingText/HeadingText";
import ButtonComponent from "components/common/Button/ButtonComponent";
import { Can } from "config/Can";
import { Col, Container, Form, Row } from "reactstrap";
import SearchableSelect from "components/common/SearchableSelect/SearchableSelect";
import FormSectionLayout from "components/layouts/FormSectionLayout";
import { TOPUP_CITIES, TOPUP_API_TYPE } from "config/constants";
import { ITopUpPage, ISearchSelectChange } from "interfaces/Index";
import { topupApiCall } from "redux/sources/TopupSource";
import "./TopupPage.scss";
import Toaster from "components/common/Toaster/Toaster";

const TopUpPage: React.FunctionComponent<ITopUpPage> = (props: ITopUpPage) => {
  const [city, selectCity] = useState<ISearchSelectChange | null>(
    props.dummyCity || null
  );
  const [isLoadWallet, setIsLoadWallet] = useState<boolean>(
    props.dummyLoadWallet || false
  );

  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  const loadWallet = () => {
    if (!city) {
      // alert("Please select the city");
      const message = "Please select the city";
      handleToaster(true, message);
    } else {
      setIsLoadWallet(true);
      topupApiCall({ city: city.value }, TOPUP_API_TYPE.LOAD)
        .then((responseData) => alert(JSON.stringify(responseData)))
        .catch((error) => alert(JSON.stringify(error)));
    }
  };

  const handleCityChange = (e: ISearchSelectChange) => {
    setIsLoadWallet(false);
    selectCity(e);
  };

  const renderForm = () => {
    return (
      <FormSectionLayout subTitleText="Topup details">
        <Toaster
          showToaster={showToaster.isVisible}
          toasterClass={
            showToaster.isError
              ? "toaster toaster-bg-danger"
              : "toaster toaster-bg-success"
          }
        >
          {showToaster.message || ""}
        </Toaster>
        <SearchableSelect
          label="city"
          options={TOPUP_CITIES}
          id="city"
          onChange={handleCityChange}
          selectedValue={city}
          placeholder="Select city"
          isSearchable={false}
        />
        <div className="form-row-separator">
          <Row className="add-update-button-container">
            <Can I="create" a="wallet">
              <Col lg="6">
                <ButtonComponent
                  buttonText="Load Batwa"
                  onClickHandler={loadWallet}
                  buttonClass={`large-button btn-primary`}
                  isDisable={isLoadWallet}
                />
              </Col>
            </Can>
          </Row>
        </div>
      </FormSectionLayout>
    );
  };

  return (
    <Container fluid className="topup-container">
      <Row>
        <Col lg="5">
          <div className="topup-main-heading">
            <HeadingText text={"Top Up"} isMainHeading={true} />
          </div>
        </Col>
      </Row>

      <Row className="form-container">
        <Col xs="12">
          <Form>{renderForm()}</Form>
        </Col>
      </Row>
    </Container>
  );
};
export default TopUpPage;
